import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  styled,
  Typography,
  Button,
  TableCell,
} from '@mui/material';

export const Container = styled(Box)(() => ({
  height: '100vh',
  paddingLeft: 20,
  paddingRight: 20,
}));

export const CustomTableCell = styled(TableCell)(() => ({
  '&.MuiTableCell-root': {
    borderBottom: 'none',
  },
}));

export const TableCellMarginBottom = styled(TableCell)(() => ({
  '&.MuiTableCell-root': {
    borderBottom: '1px solid',
  },
}));

export const TypographyBounces = styled(Typography)(() => ({
  fontWeight: 'bold',
}));

export const DeliveryError = styled(Box)(() => ({
  width: '80%',
  marginLeft: '10%',
  borderRadius: 8,
}));

export const BoxEmail = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: '3%',
  marginLeft: '10%',
  padding: 5,
  width: '80%',
  height: 30,
  border: '1px solid',
  borderRadius: 8,
}));

export const ReSendButton = styled(Button)(() => ({
  width: 120,
  backgroundColor: '#2E3192',
  color: '#fff',
  borderRadius: 8,
  textTransform: 'initial',

  '&:hover': {
    backgroundColor: '#3c52b2',
  },
}));

export const DeliveryErrorContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '95%',
  borderRadius: 8,
  padding: 10,
  height: 220,
  marginTop: 10,
  backgroundColor: '#fff',
  overflowY: 'auto',
}));

export const BouncesDetails = styled(Box)(() => ({
  display: 'grid',
  width: '73%',
  marginLeft: '15%',
  height: 590,
  borderRadius: 8,
  backgroundColor: '#2E3192',
  boxShadow: '2px 2px  #C2C2C2',
}));

export const AlignBouncesAndChart = styled(Box)(
  ({ theme: { breakpoints } }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    width: '100%',
    height: 600,
    overflowY: 'auto',

    [breakpoints.up('xl')]: {
      paddingTop: 30,
    },
  })
);

export const AlignIconButton = styled(Box)(() => ({
  display: 'flex',
  width: 40,
  height: 40,
  marginLeft: 50,
}));

export const CardWrapper = styled(Grid)(({ theme }) => ({
  width: '100%',

  [theme.breakpoints.down('xl')]: {
    marginTop: -20,
  },
}));

export const CardItem = styled(Card)(({ theme: { palette }, theme }) => ({
  width: '80%',
  height: 200,
  backgroundColor: palette.background.default,
  boxShadow: '5px 0px 12px 0px rgba(0,0,0,0.57)',
  transition: 'all 0.4s ease',

  '&:hover': {
    transform: 'scale(1.03)',
  },

  [theme.breakpoints.down('xl')]: {
    width: '70%',
    height: 150,
    borderRadius: 8,

    '& .MuiSvgIcon-root': {
      fontSize: 20,
    },
  },
}));

export const TopBarContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
}));

export const CardItemTitle = styled(Typography)(
  ({ theme: { breakpoints } }) => ({
    fontSize: 20,
    paddingRight: 10,

    [breakpoints.down('xl')]: {
      fontSize: 14,

      '& .MuiSvgIcon-root': {
        fontSize: 20,
      },
    },
  })
);

export const GoToIconButton = styled(IconButton)(
  ({ theme: { breakpoints } }) => ({
    width: 25,
    height: 25,
    padding: 5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',

    '&:hover': {
      transform: 'scale(1.2)',
      backgroundColor: 'transparent',
    },

    [breakpoints.down('xl')]: {
      width: 20,
      height: 20,

      '& .MuiSvgIcon-root': {
        fontSize: 20,
      },
    },
  })
);

export const ToolTipText = styled(Typography)(({ theme: { breakpoints } }) => ({
  fontsize: 13,

  [breakpoints.down('xl')]: {
    fontsize: 9,
  },
}));

export const CardInnerWrapper = styled(CardContent)(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: 20,
}));

export const ContainerWrapper = styled(Grid)(() => ({
  width: '100%',
  marginTop: 30,
}));

export const FirstContainer = styled(Grid)(
  ({ theme: { breakpoints, palette } }) => ({
    height: 100,
    width: 130,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 0,
    backgroundColor: palette.primary.main,

    [breakpoints.down('xl')]: {
      height: 60,
    },
  })
);

export const SummaryNumber = styled(Typography)(
  ({ theme: { breakpoints } }) => ({
    fontSize: 24,
    fontWeight: 'bold',
    color: '#FFF',

    [breakpoints.down('xl')]: {
      fontSize: 16,
    },
  })
);

export const SummaryText = styled(Typography)(({ theme: { breakpoints } }) => ({
  fontSize: 16,
  color: '#FFF',

  [breakpoints.down('xl')]: {
    fontSize: 10,
  },
}));

export const SecondContainer = styled(Grid)(
  ({ theme: { breakpoints, palette } }) => ({
    height: 100,
    width: 130,
    display: 'flex',
    flexDirection: 'column',
    padding: 10,
    borderRadius: 0,
    backgroundColor: palette.primary.main,

    [breakpoints.down('xl')]: {
      height: 90,
    },
  })
);

export const LoadingContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: 30,
}));

export const NoWrapSpan = styled('span')(() => ({
  width: '100%',
  height: 'auto',
  display: 'inline-block',
  whiteSpace: 'nowrap',
  overflow: 'hidden !important',
  textOverflow: 'ellipsis',
}));

export const ContainerTitleTextStyled = styled(Typography)(
  ({ theme: { breakpoints } }) => ({
    fontSize: 28,
    fontWeight: 'bold',

    [breakpoints.down('xl')]: {
      fontSize: 20,
    },
  })
);
